// @ts-ignore
import { gtag, install } from 'ga-gtag';
const id = "G-E22XKR86C8"
export const callMeBackConversion=()=>{
    install(id)
  gtag('event', 'call_back');
  return false;
}

